export function formatForUpload(loggingArgs, userSessionId, uploadId, timestampBase) {
    var entries = loggingArgs.map(function (element) { return getLogEntryInWireFormat(element, timestampBase); });
    var batch = getLogBatchInWireFormat(timestampBase, entries, userSessionId, uploadId);
    return JSON.stringify(batch);
}
/** Use this to shift up another int before adding the Level when concatenating for serialization. */
var shiftFactory = 1000;
/** Serialize a single bULS entry into over-the-wire format */
function getLogEntryInWireFormat(loggingArgs, timestampBase) {
    var entry = {};
    entry['G'] = loggingArgs.tag;
    entry['T'] = loggingArgs.timestamp - timestampBase;
    entry['M'] = loggingArgs.message;
    entry['C'] = loggingArgs.category;
    // level and logType are combined into a single property called metadata
    var metadata = loggingArgs.type * shiftFactory + loggingArgs.level;
    entry['D'] = metadata;
    return entry;
}
function getLogBatchInWireFormat(timestampBase, logs, userSessionId, uploadId) {
    var batch = {};
    batch['T'] = timestampBase;
    batch['L'] = logs;
    batch['S'] = userSessionId;
    batch['I'] = uploadId;
    // schema version
    batch['V'] = 1;
    return batch;
}
//# sourceMappingURL=bUlsFormatter.js.map